import ModeloUpdate from './ModeloUpdate'
export {ModeloUpdate}
export default ModeloUpdate
